import { useDbClient } from "@tanstack/react-db";
import { useQuery } from "@tanstack/react-query";

import { prefetchProviders } from "./providers-collection";

const PREFETCH_STALE_TIME_MS = 5 * 60 * 1000;

export function usePrefetchProviders(providerIds: string[]) {
    const dbClient = useDbClient();
    const prefetchKey = [...new Set(providerIds)].sort().join("|");

    useQuery({
        queryKey: ["prefetch-organizations", prefetchKey],
        queryFn: async () => {
            await prefetchProviders(dbClient, prefetchKey.split("|"));
            return null;
        },
        enabled: Boolean(prefetchKey),
        staleTime: PREFETCH_STALE_TIME_MS,
    });
}
